import { useDispatch } from 'react-redux';
import { openModal } from 'actions/modal';
import { MODAL_FORM } from 'constants/form';

const useLogic = ({ timezone, prospectID }) => {
  const dispatch = useDispatch();

  const handleOpenBookTrialClassModal = ({ name, id, date }) => {
    console.log('teacherid,', id);
    dispatch(
      openModal(
        MODAL_FORM.AC_LED_MAPPING_BOOK_TRIAL_CLASS_MODAL,
        {
          size: 'custom',
          width: '542px',
        },
        {
          teacherName: name,
          teacherID: id,
          timezone,
          prospectID,
          selectedDate: date,
        },
      ),
    );
  };

  return {
    handleOpenBookTrialClassModal,
  };
};

export default useLogic;
